<template>
  <div id="history">
    <div class="box-title">
      <p>{{ $t("message.strid47") }}</p>
    </div>
    <div class="table-title">
      <div class="c1"><span>{{$t("message.strid35")}}</span></div>
      <div class="c2"><span>{{$t("message.strid36")}}</span></div>
      <div class="c3"><span>{{$t("message.strid37")}}</span></div>
      <div class="c4"><span>{{$t("message.strid38")}}</span></div>
    </div>
    <div class="table-box">
      <div class="item" v-for="(item, index) in _history" :key="index">
        <div class="c1"><span>{{item.apply_time_cus && item.apply_time_cus.split(' ')[0]}}</span></div>
        <div class="c2"><span>{{item.event_name}}</span></div>
        <div class="c3"><span>{{item.event_duration && item.event_duration | setEmail}}</span></div>
        <div class="c4" :class="item.status | setClass"><span>{{getValue(item.status)}}</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
   computed: {
    ...mapState(["_history"]),
  },
  mounted () {
    if (Cookies.get('his')) {
      this.$store.dispatch('setHis', JSON.parse(Cookies.get('his')))
    }
    if(this._history.length == 0) {
      this.$router.replace({name: 'search'})
    }
  },
  methods: {
    getValue(value){
      switch (value) {
        case 1:
          return this.$t("message.strid32");
        case 2:
          return 'Verifying'
        case 3:
          return this.$t("message.strid33"); 
        case 4:
          return this.$t("message.strid34");
      }
    }
  },
  filters: {
    setClass (value) {
      switch (value) {
        case 3:
          return 'success'
        case 4:
          return 'fail'
      }
    },
    setName (value) {
      return '1'
      // switch (value) {
      //   case 1:
      //     return $t("message.strid32");
      //   case 2:
      //     return 'Verifying'
      //   case 3:
      //     return $t("message.strid33"); 
      //   case 4:
      //     return $t("message.strid34");
      // }
    },
    setEmail (value) {
      if (!value) {
        return false
      }
      const t1 = value.substring(0, 10).replace(/-/g, '/')
      const t2 = value.substring(11, 21).replace(/-/g, '/')
      return `${t1} - ${t2}`
    }
  }
}
</script>

<style lang="scss">
@media screen and (min-width: $mimViewWidth) {
  @import "@/assets/scss/views/history.scss";
}
@media screen and (max-width: $maxViewWidth) {
  @import "@/assets/scss/views/m/history.scss";
}
</style>